"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MemberType;
(function (MemberType) {
    MemberType["PENDING"] = "PENDING";
    MemberType["GROUP"] = "GROUP";
})(MemberType = exports.MemberType || (exports.MemberType = {}));
var MemberDTO = /** @class */ (function () {
    function MemberDTO(member) {
        this.member = member;
    }
    MemberDTO.prototype.getImageUrl = function () {
        return this.member.imageUrl;
    };
    MemberDTO.prototype.getName = function (anon) {
        var name = this.member.name;
        return (name && name.nick) || anon;
    };
    MemberDTO.prototype.getId = function () {
        return this.member.siteMemberId;
    };
    MemberDTO.prototype.getAnswersCount = function () {
        return this.member.membershipQuestionAnswersCount;
    };
    MemberDTO.prototype.hasAnswers = function () {
        return this.getAnswersCount() > 0;
    };
    MemberDTO.prototype.getRequestDate = function () {
        return this.member.requestedMembershipOn;
    };
    /**
     *
     * @param {GroupMember} other
     * @param anon
     * @param {string} locale - Unicode BCP 47 locale
     */
    MemberDTO.prototype.compareName = function (other, anon, locale) {
        return this.getName(anon).localeCompare(other.getName(anon), locale, {
            sensitivity: 'base',
        });
    };
    MemberDTO.prototype.isPending = function () {
        return false;
    };
    return MemberDTO;
}());
exports.MemberDTO = MemberDTO;
//# sourceMappingURL=MemberDTO.js.map